export var TextFieldTypes;
(function (TextFieldTypes) {
    TextFieldTypes["text"] = "text";
    TextFieldTypes["number"] = "number";
    TextFieldTypes["password"] = "password";
})(TextFieldTypes || (TextFieldTypes = {}));
export var InputMasks;
(function (InputMasks) {
    InputMasks["data"] = "data";
    InputMasks["cpf"] = "cpf";
    InputMasks["cnpj"] = "cnpj";
    InputMasks["cep"] = "cep";
    InputMasks["celular"] = "celular";
    InputMasks["email"] = "email";
    InputMasks["currency"] = "currency";
})(InputMasks || (InputMasks = {}));
//# sourceMappingURL=constants.js.map